import SensorLogApi from "../../../api/sensor-log-api";

// initial state
const initialState = () => ({
  isFetching: false,
  data: [],
  debugData: [],
  thiData: [],
  latest: []
});

// actions
const actions = {
  getSensorLogs: async ({ commit }, payload) => {
    try {
      commit("request", payload);
      const { fromDate, toDate, cowIDs, bolusIDs, limit } = payload;
      const apiResponse = await SensorLogApi.list(fromDate, toDate, cowIDs, bolusIDs, limit);
      if (apiResponse && apiResponse.data) {
        commit("getSensorLogsSuccess", apiResponse.data);
      } else {
        commit("getSensorLogsFailed", apiResponse);
      }
    } catch (e) {
      commit("getSensorLogsFailed", e);
    }
  },

  getDebugSensorLogs: async ({ commit }, payload) => {
    try {
      commit("requestDebug", payload);
      const { fromDate, toDate, cowIDs, bolusIDs, limit, abnormalOnly } = payload;
      const apiResponse = await SensorLogApi.debugList(fromDate, toDate, cowIDs, bolusIDs, limit, abnormalOnly);
      if (apiResponse && apiResponse.data) {
        commit("getDebugSensorLogsSuccess", apiResponse.data);
      } else {
        commit("getDebugSensorLogsFailed", apiResponse);
      }
    } catch (e) {
      commit("getDebugSensorLogsFailed", e);
    }
  },

  getThiSensorLogs: async ({ commit }, payload) => {
    try {
      commit("requestThi", payload);
      const { fromDate, toDate, limit } = payload;
      const apiResponse = await SensorLogApi.thiList(fromDate, toDate, null, limit);
      if (apiResponse && apiResponse.data) {
        commit("getThiSensorLogsSuccess", apiResponse.data);
      } else {
        commit("getThiSensorLogsFailed", apiResponse);
      }
    } catch (e) {
      commit("getThiSensorLogsFailed", e);
    }
  },

  getLatestSensorLogs: async ({ commit }) => {
    try {
      commit("requestLatest");
      const apiResponse = await SensorLogApi.getLatestSensorLogs();
      if (apiResponse && apiResponse.data) {
        commit("getLatestSensorLogsSuccess", apiResponse.data);
      } else {
        commit("getLatestSensorLogsFailed", apiResponse);
      }
    } catch (e) {
      commit("getLatestSensorLogsFailed", e);
    }
  },

  clearSensorLogs: ({ commit }) => {
    commit("clearSensorLogs", initialState().data);
  },
  clearDebugSensorLogs: ({ commit }) => {
    commit("clearDebugSensorLogs", initialState().debugData);
  },
  clearThiSensorLogs: ({ commit }) => {
    commit("clearThiSensorLogs", initialState().thiData);
  },

  showLoadingModal: ({ commit }) => {
    commit("request");
  },
  hideLoadingModal: ({ commit }) => {
    commit("hideLoadingModal");
  }
};

// mutations
const mutations = {
  request: state => {
    state.isFetching = true;
  },
  requestDebug: state => {
    state.isFetching = true;
  },
  requestThi: state => {
    state.isFetching = true;
  },
  requestLatest: () => {
    // We dont want wait for this atm
    // state.isFetching = true;
  },
  getSensorLogsSuccess: (state, payload = {}) => {
    state.isFetching = false;
    state.data = payload;
  },
  getSensorLogsFailed: state => {
    state.isFetching = false;
  },
  getDebugSensorLogsSuccess: (state, payload = {}) => {
    state.isFetching = false;
    state.debugData = payload;
  },
  getDebugSensorLogsFailed: state => {
    state.isFetching = false;
  },
  getThiSensorLogsSuccess: (state, payload = {}) => {
    state.isFetching = false;
    state.thiData = payload;
  },
  getThiSensorLogsFailed: state => {
    state.isFetching = false;
  },
  getLatestSensorLogsSuccess: (state, payload = {}) => {
    state.isFetching = false;
    state.latest = payload;
  },
  getLatestSensorLogsFailed: () => {
    // state.isFetching = false;
  },
  clearSensorLogs: (state, initialState) => {
    state.data = initialState;
  },
  clearDebugSensorLogs: (state, initialState) => {
    state.debugData = initialState;
  },
  clearThiSensorLogs: (state, initialState) => {
    state.thiData = initialState;
  },
  hideLoadingModal: state => {
    state.isFetching = false;
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/plugins/store/modules/sensor-logs.js